'use client';

import { RootProvider } from 'fumadocs-ui/provider/next';
import type { ReactNode } from 'react';
// import { DocsSearchVisibility } from '@/components/docs-search-visibility';

export function Provider({
  children,
  i18n,
  lang,
}: {
  children: ReactNode;
  i18n: Parameters<typeof RootProvider>[0]['i18n'];
  lang?: string;
}) {
  return (
    <RootProvider
      i18n={i18n}
      theme={{ enableSystem: false, defaultTheme: 'light' }}
      search={{
        // 禁用全局快捷键唤起搜索（默认 ⌘K / Ctrl+K）。勿用 hotKey: []：every 对空数组为 true 会误触发。
        hotKey: [{ key: () => false, display: null }],
      }}
    >
      {/* <DocsSearchVisibility /> — 见 docs/[[...slug]]/layout searchToggle */}
      {children}
    </RootProvider>
  );
}